module.exports = __webpack_public_path__ + "img/exclamation.c56aa28f.svg";